/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Audio_Recorder_Duration_ValueInputs */

const en_audio_recorder_duration_value = /** @type {(inputs: Audio_Recorder_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
};

const fr_audio_recorder_duration_value = /** @type {(inputs: Audio_Recorder_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
};

const de_audio_recorder_duration_value = /** @type {(inputs: Audio_Recorder_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
};

const it_audio_recorder_duration_value = /** @type {(inputs: Audio_Recorder_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
};

const ru_audio_recorder_duration_value = /** @type {(inputs: Audio_Recorder_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
};

const es_audio_recorder_duration_value = /** @type {(inputs: Audio_Recorder_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
};

const zh_cn2_audio_recorder_duration_value = /** @type {(inputs: Audio_Recorder_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
};

const ja_audio_recorder_duration_value = /** @type {(inputs: Audio_Recorder_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
};

const hi_audio_recorder_duration_value = /** @type {(inputs: Audio_Recorder_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
};

const pt_pt2_audio_recorder_duration_value = /** @type {(inputs: Audio_Recorder_Duration_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
};

/**
* | output |
* | --- |
* | "{seconds}s" |
*
* @param {Audio_Recorder_Duration_ValueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_duration_value = /** @type {((inputs: Audio_Recorder_Duration_ValueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Duration_ValueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_duration_value(inputs)
	if (locale === "de") return de_audio_recorder_duration_value(inputs)
	if (locale === "it") return it_audio_recorder_duration_value(inputs)
	if (locale === "ru") return ru_audio_recorder_duration_value(inputs)
	if (locale === "es") return es_audio_recorder_duration_value(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_duration_value(inputs)
	if (locale === "ja") return ja_audio_recorder_duration_value(inputs)
	if (locale === "hi") return hi_audio_recorder_duration_value(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_duration_value(inputs)
	return en_audio_recorder_duration_value(inputs)
});